const admin = {
  accessDenied: {
    title: 'Acceso denegado',
    description: 'Esta área está restringida solo para administradores.',
  },
  title: 'Panel de administración',
  tabs: {
    sessions: 'Sesiones',
    traces: 'Trazas',
    costSummary: 'Resumen de costos',
    analytics: 'Analíticas',
    feedback: 'Comentarios',
    reports: 'Informes',
  },
  actions: {
    close: 'Cerrar',
    refresh: 'Actualizar',
    refreshData: 'Actualizar datos',
    reset: 'Restablecer',
    resetFilters: 'Restablecer filtros',
    resetToDefaults: 'Restablecer valores predeterminados',
    previous: 'Anterior',
    next: 'Siguiente',
    details: 'Detalles',
    view: 'Ver',
    exportCsv: 'Exportar CSV',
    exporting: 'Exportando...',
    viewHtml: 'Ver HTML',
    viewPdf: 'Ver PDF',
    delete: 'Eliminar',
    deleteReport: 'Eliminar informe',
    generateReport: 'Generar informe',
    generateNewReport: 'Generar nuevo informe',
    cancel: 'Cancelar',
    generating: 'Generando...',
    viewTrace: 'Ver traza',
    copy: 'Copiar',
    copied: 'Copiado',
    full: 'Completo',
    viewFullData: 'Ver datos completos',
    viewFullOutput: 'Ver resultado completo',
  },
  filters: {
    dateRange: 'Intervalo de fechas',
    customRange: 'Intervalo personalizado',
    today: 'Hoy',
    lastDays: 'Últimos {{count}} días',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de finalización',
    customerId: 'ID de cliente',
    allCustomers: 'Todos los clientes',
  },
  errors: {
    label: 'Error:',
  },
  status: {
    loading: 'Cargando...',
    loadingData: 'Cargando datos de administración',
    noData: 'No se encontraron datos',
  },
  labels: {
    notAvailable: 'N/D',
  },
  sessions: {
    title: 'Sesiones de chat',
    excludeEmpty: 'Excluir sesiones vacías',
    userInitiatedOnly: 'Solo iniciadas por el usuario',
    total: '{{count}} sesiones en total',
    noResults: 'No se encontraron sesiones que coincidan con los filtros.',
    noSessionsToExport: 'No hay sesiones para exportar',
    exportFailed: 'No se pudieron exportar las sesiones a CSV',
    exportAll: 'Exportar todas las sesiones a CSV',
    noMessages: 'Sin mensajes',
    viewAnalysis: 'Ver análisis con puntuación {{score}}',
    viewLinkClicks: 'Ver {{count}} clics de enlace',
    headers: {
      user: 'Usuario',
      customer: 'Cliente',
      source: 'Origen',
      firstMessage: 'Primer mensaje',
      started: 'Iniciada',
      messages: 'Mensajes',
      analysis: 'Análisis',
      linkClicks: 'Clics de enlace',
      details: 'Detalles',
    },
  },
  traces: {
    title: 'Trazas de mensajes',
    summary: 'Mostrando {{visible}} de {{total}} trazas',
    headers: {
      messageId: 'ID del mensaje',
      traceId: 'ID de traza',
      createdAt: 'Creada el',
      inputTokens: 'Tokens de entrada',
      outputTokens: 'Tokens de salida',
      time: 'Tiempo',
      actions: 'Acciones',
    },
  },
  costSummary: {
    title: 'Resumen de costos',
    noData: 'No hay datos de costos para el intervalo de fechas seleccionado.',
    totalCost: 'Costo total',
    totalTokens: 'Tokens totales',
    inputTokens: 'Tokens de entrada',
    outputTokens: 'Tokens de salida',
    dailyBreakdown: 'Desglose diario',
    noDailyData: 'No hay datos de costos diarios para este período.',
    headers: {
      date: 'Fecha',
      messages: 'Mensajes',
      inputTokens: 'Tokens de entrada',
      outputTokens: 'Tokens de salida',
      cacheTokens: 'Tokens de caché',
      cost: 'Costo',
    },
  },
  analytics: {
    title: 'Analíticas de uso de tokens',
    noData: 'No hay datos de analíticas para el intervalo de fechas seleccionado.',
    dateRange: 'Mostrando datos desde {{start}} hasta {{end}}',
    noPeriodData: 'No hay datos de analíticas para este período.',
    headers: {
      date: 'Fecha',
      messages: 'Mensajes',
      inputTokens: 'Tokens de entrada',
      outputTokens: 'Tokens de salida',
      cacheTokens: 'Tokens de caché',
      toolsExecuted: 'Herramientas ejecutadas',
      averageResponseTime: 'Tiempo de respuesta medio',
    },
  },
  feedback: {
    title: 'Comentarios sobre mensajes',
    total: '{{count}} registros de comentarios en total',
    noResults: 'No se encontraron comentarios que coincidan con los filtros.',
    noSessionId: 'No hay un ID de sesión disponible para estos comentarios.',
    sessionLoadFailed: 'No se pudieron cargar los detalles de la sesión.',
    headers: {
      submitted: 'Enviado',
      rating: 'Valoración',
      messagePreview: 'Vista previa del mensaje',
      comments: 'Comentarios',
      customer: 'Cliente',
      user: 'Usuario',
      session: 'Sesión',
    },
  },
  reports: {
    title: 'Informes de análisis',
    total: '{{count}} informes en total',
    deleteConfirmation: '¿Seguro que desea eliminar este informe?',
    deleteFailed: 'No se pudo eliminar el informe.',
    loading: 'Cargando informes...',
    noResults: 'No se encontraron informes para los filtros seleccionados.',
    createPrompt: 'Seleccione Generar informe para crear un nuevo informe de análisis.',
    status: {
      completed: 'Completado',
      failed: 'Error',
      inProgress: 'En curso',
      pending: 'Pendiente',
    },
    rangeType: {
      monthly: 'Mensual',
      quarterly: 'Trimestral',
      custom: 'Personalizado',
    },
    headers: {
      id: 'ID',
      status: 'Estado',
      type: 'Tipo',
      dateRange: 'Intervalo de fechas',
      sessions: 'Sesiones',
      generated: 'Generado',
      actions: 'Acciones',
    },
  },
  modals: {
    close: 'Cerrar',
    identifier: 'ID: {{id}}',
    generateReport: {
      title: 'Generar informe de análisis',
      invalidDateRange: 'Seleccione un intervalo de fechas válido.',
      generationFailed: 'No se pudo generar el informe.',
      insufficientConfirmation: 'Solo hay {{available}} registros de análisis disponibles (se recomiendan al menos {{minimum}}). ¿Desea continuar?',
      successTitle: 'La generación del informe se inició correctamente.',
      successDescription: 'El informe puede tardar varios minutos en generarse. Puede supervisar el progreso en la pestaña Informes.',
      reportType: 'Tipo de informe',
      month: 'Mes',
      year: 'Año',
      quarter: 'Trimestre',
      quarterOption: 'T{{quarter}} ({{start}}-{{end}})',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de finalización',
      customerId: 'ID de cliente (opcional)',
      allCustomers: 'Déjelo en blanco para todos los clientes',
      checkingAvailability: 'Comprobando los registros de análisis disponibles...',
      availability: '{{count}} registros de análisis disponibles',
      limitedAvailability: 'Solo hay {{count}} registros de análisis disponibles (se recomiendan al menos {{minimum}})',
    },
    sessionDetail: {
      title: 'Detalles de la sesión',
      overview: 'Resumen',
      sessionId: 'ID de sesión:',
      customer: 'Cliente:',
      user: 'Usuario:',
      started: 'Iniciada:',
      lastActivity: 'Última actividad:',
      totalMessages: 'Total de mensajes:',
      messages: 'Mensajes ({{count}})',
      userRole: 'Usuario',
      assistantRole: 'Asistente',
      fleet: 'Flota:',
      helpful: 'Útil',
      notHelpful: 'No útil',
      loadingMap: 'Cargando mapa...',
      noTrace: 'No hay datos de traza disponibles para este mensaje.',
      traceLoadFailed: 'No se pudieron cargar los detalles de la traza.',
      loadingTrace: 'Cargando traza',
    },
    feedbackDetail: {
      title: 'Detalles de comentarios',
      overview: 'Resumen',
      rating: 'Valoración:',
      positive: 'Positiva',
      negative: 'Negativa',
      submitted: 'Enviado:',
      customer: 'Cliente:',
      user: 'Usuario:',
      sessionId: 'ID de sesión:',
      message: 'Mensaje',
      comments: 'Comentarios',
      viewRelatedSession: 'Ver sesión relacionada',
      noSession: 'No hay un ID de sesión asociado con estos comentarios.',
      sessionLoadFailed: 'No se pudieron cargar los detalles de la sesión.',
    },
    linkClicks: {
      title: 'Clics de enlace ({{count}})',
      loadFailed: 'No se pudieron cargar los clics de enlace.',
      loading: 'Cargando clics de enlace...',
      noResults: 'No se registraron clics de enlace para esta sesión.',
      headers: {
        userEmail: 'Correo del usuario',
        url: 'URL',
        linkText: 'Texto del enlace',
        type: 'Tipo',
        clickedAt: 'Se hizo clic el',
      },
    },
    traceDetail: {
      title: 'Detalles de la traza',
      overview: 'Resumen',
      traceId: 'ID de traza:',
      model: 'Modelo:',
      customerId: 'ID de cliente:',
      totalTime: 'Tiempo total:',
      inputTokens: 'Tokens de entrada:',
      outputTokens: 'Tokens de salida:',
      cacheRead: 'Lectura de caché:',
      stopReason: 'Motivo de detención:',
      message: 'Mensaje',
      events: 'Eventos ({{count}})',
      tool: 'Herramienta:',
      useId: 'ID de uso:',
      inputParameters: 'Parámetros de entrada',
      output: 'Resultado',
      intent: 'Intención:',
      intentScore: 'Puntuación de intención:',
      contextMessagesUsed: 'Mensajes de contexto usados:',
      contextMessagesRendered: 'Mensajes de contexto representados:',
      contextMessageIds: 'ID de mensajes de contexto ({{count}})',
      systemPrompt: 'Instrucción del sistema',
      metadata: 'Metadatos',
      reasoning: 'Razonamiento:',
      toolExecutions: 'Ejecuciones de herramientas ({{count}})',
      success: 'Correcto',
      failed: 'Error',
      sessionDocuments: 'Documentos de sesión ({{count}})',
      sessionDocument: 'Documento de sesión',
      mapSessionDocument: 'Documento de sesión de mapa',
      documentSessionDocument: 'Documento de sesión',
      type: 'Tipo:',
      summary: 'Resumen:',
      documentId: 'ID de documento:',
      toolUseId: 'ID de uso de herramienta:',
      created: 'Creado:',
      data: 'Datos',
      truncated: 'truncados',
    },
    sessionAnalysis: {
      title: 'Análisis de la sesión',
      overview: 'Resumen del análisis',
      overallScore: 'Puntuación general',
      clarityScore: 'Puntuación de claridad',
      actionabilityScore: 'Puntuación de accionabilidad',
      responseQualityScore: 'Puntuación de calidad de respuesta',
      details: 'Detalles del análisis',
      intentSummary: 'Resumen de intención:',
      isFailure: 'Es un error:',
      yes: 'Sí',
      no: 'No',
      validationStatus: 'Estado de validación:',
      modelId: 'ID del modelo:',
      analysisVersion: 'Versión del análisis:',
      analysisTime: 'Hora del análisis:',
      validationMessages: 'Mensajes de validación',
      fullJson: 'JSON completo del análisis',
      noJson: 'No hay JSON de análisis disponible',
    },
    toolOutput: {
      title: 'Resultado de herramienta: {{name}}',
      sessionDocumentTitle: 'Datos del documento de sesión: {{title}}',
      copyData: 'Copiar datos al portapapeles',
      copyOutput: 'Copiar resultado al portapapeles',
      loadingData: 'Cargando datos...',
      loadingOutput: 'Cargando resultado...',
      noData: 'No hay datos disponibles',
      noOutput: 'No hay resultado disponible',
      sessionDocumentDataRequired: 'Se requiere un ID de sesión para obtener datos del documento de sesión.',
      outputRequired: 'Se requiere un ID de sesión para obtener el resultado.',
      dataLoadFailed: 'No se pudieron cargar los datos del documento de sesión.',
      outputLoadFailed: 'No se pudo cargar el resultado.',
    },
  },
  pagination: {
    summary: 'Mostrando {{start}} a {{end}} de {{total}} resultados',
    detailedSummary: 'Mostrando {{start}} a {{end}} de {{total}} resultados (página {{currentPage}} de {{totalPages}})',
    pageSummary: 'Página {{currentPage}} de {{totalPages}}',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
  },
} as const;

export default admin;